import { AsyncState, loadedAsyncState, loadingAsyncState } from "widgets-for-react";
import { fetchSearchResults } from "./searchPageApi";
import { SearchablePage } from "../../../../Shared/api/elasticsearch/elasticsearchTypes";

export interface SearchPageState {
  searchResults: AsyncState<SearchResult>
  searchQuery: string
  pageSize: number
  currentPage: number
}

export type SearchPageLayoutProps = SearchPageState & {
  updateQuery: (query: string) => void
  updatePage: (page: number) => void
  runQuery: () => void
}

export type SearchResult = {
  results: SearchablePage[]
  totalResults: number
  query: string
  page: number
}

export const emptySearchResult: SearchResult = {
  results: [],
  totalResults: 0,
  query: "",
  page: 1
}

const initialPageSize = 5

export const initialState: () => SearchPageState = () => {
  const allParams = new URLSearchParams(window.location.search)
  const query = allParams.get(searchParam)
  const initialSearchQuery = query ? decodeURIComponent(query) : ''
  return {
    pageSize: initialPageSize,
    searchQuery: initialSearchQuery,
    searchResults: initialSearchQuery
      ? loadingAsyncState(fetchSearchResults(initialSearchQuery, 1, initialPageSize))
      : loadedAsyncState<SearchResult>(emptySearchResult),
    currentPage: 1
  }
}

export const searchResultsRoute: string = '/zoeken'
export const searchParam: string = 'q'
